import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Component, OnInit, ViewEncapsulation, OnDestroy, Output, EventEmitter } from '@angular/core';
import { RegisterOfBenefactorsService } from '../register-of-benefactors.service';
import { TableDetailDataSource } from '../../../utils/table-detail-data-source';
import { BenefactorModel } from '../../models/benefactor';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { EventTypes } from '../../../shared/EventTypes';
import { RegisterOfBenefactorsEventType } from '../register-of-benefactors.event.type';
import { TweenMax, Quint } from 'gsap';
import { Bank } from './../../models/banks';
import { BenefactorDataModel } from '../../models/benefactorData';


@Component({
	selector: 'app-list-benefactors',
	templateUrl: './list-benefactors.component.html',
	styleUrls: ['./list-benefactors.component.styl'],
	encapsulation: ViewEncapsulation.None,
	animations: [
		trigger('detailExpand', [
		state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
		  state('expanded', style({height: '*'})),
		  transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
		]),
	  ],
})

export class ListBenefactorsComponent implements OnInit, OnDestroy {

	@Output() setTitle: EventEmitter<any> = new EventEmitter<any>();

	private view = '[data-component="list-benefactors"]';
	active: boolean = false;
	isLoading = true;
	message: string = '';
	success: boolean = false;
	addForm: FormGroup;
	private banks: Array<Bank> = [];

	benefactorDelete: BenefactorDataModel = {};
	accountIndex: number;


	dataSource: TableDetailDataSource = new TableDetailDataSource();
	
	displayedColumns = ['name', 'cpf'];
	expandedElement: BenefactorModel | null;
	isExpansionDetailRow = (i: number, row: Object) => row.hasOwnProperty('detailRow');


	constructor( private benefactorsService: RegisterOfBenefactorsService ) { 
		this.benefactorsService.getBanks().subscribe(data => {
			data.map(item => {
				this.banks[item.code] = {
					name: item.name,
					label: item.label,
				}
			});
		});
	}

	ngOnInit() {
		AppEventDispatcher.listen(RegisterOfBenefactorsEventType.STEPS.BENEFACTOR_LIST, data => {
			this.setTitle.emit({
				title: 'Favorecidos',
			});

			if (data.benefactorData) {
				this.message = data.benefactorData.message;
				this.success = data.benefactorData.success;
			}

			this.active = true;
			TweenMax.delayedCall(.3, () => {
				this.getAll();
			});
		});		
	}

	getAll() {
		this.preload(true);
		this.dataSource.data = [];
		this.benefactorsService.getAll().subscribe( dados => {
			this.dataSource.data = dados;
			this.isLoading = false;
		
			TweenMax.delayedCall(.3, () => {
				this.show();
			});
			this.preload(false);
		}, error => {
			this.preload(false);
			this.isLoading = false;
			TweenMax.delayedCall(.3, () => {
				this.show();
			});
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});
	}

	show() {
		TweenMax.delayedCall(.5, () => {
			const containerHeight = $(this.view).outerHeight() + $('.buttons').outerHeight() + 80;
			TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
			TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});
		});
	}

	hide() {
		TweenMax.delayedCall(1, () => {
			TweenMax.to(this.view, 0.8, {
				delay: 0.4,
				left: '-120%',
				ease: Quint.easeOut,
				onComplete: () => {
					this.active = false;
				}
			});
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(RegisterOfBenefactorsEventType.STEPS.BENEFACTOR_LIST);
	}

	goToAddBenefactor(benefactor, account) {
		this.preload(true);
		TweenMax.delayedCall(1, () => {
			
			TweenMax.delayedCall(.3, () => {
				AppEventDispatcher.dispatch(
					RegisterOfBenefactorsEventType.STEPS.BENEFACTOR_ADD.BENEFACTOR_ADD,{ show: true, benefactor: benefactor, accountIndex: account }
				);
			});

			TweenMax.to(this.view, 0.8, {
				delay: 0.4,
				left: '-100%',
				ease: Quint.easeOut,
				onComplete: () => {
					this.active = false;
				}
			});
		});
	}

	goToDeleteBenefactor(benefactor, account) {
		this.benefactorDelete = benefactor;
		this.accountIndex = account;

		this.hide();
		
		TweenMax.delayedCall(.3, () => {
			AppEventDispatcher.dispatch(RegisterOfBenefactorsEventType.STEPS.BENEFACTOR_ADD.BENEFACTOR_ADD, { show: true, benefactor: this.benefactorDelete, accountIndex: this.accountIndex, delete: true });
		});
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{ element: '[data-component="list-benefactors"] .content', show: active, delay: delay });
	}

}


// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/register-of-benefactors/list-benefactors/list-benefactors.component.ts